<template>
  <div id="budget-show">
    <div id="page-head">
      <ul id="breadcrumbs">
        <li>
          <router-link :to="{ name: 'Dashboard' }">Dashboard</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'BudgetIndex', hash: '#' + this.$route.params.clientId }">Budget Manager</router-link>
        </li>
        <li>Investment Details</li>
      </ul>
    </div>

    <loading height="1200px" v-if="status.loading"></loading>

    <div v-else-if="status.loading == false && status.error == false">
      <yearly-budget @update="updateData()" :budgets="budgets" :client="budget.client"></yearly-budget>
      <logs @update="updateData()" :budget="budget"></logs>
      <fund-manager @update="updateData()" :budget="budget"></fund-manager>
    </div>
    <div v-else-if="status.loading == false && status.error == true">
      <div class="panel error-panel">
        <div class="panel-content">
          <p
            class="message"
          >Budget data isn't available or hasn't been entered for the year {{getYear}}</p>
          <button class="button button-blue" @click.prevent="goBack()">Go Back</button>
        </div>
      </div>
    </div>
    <router-link :to="{ name: 'BudgetIndex', hash: '#' + this.$route.params.clientId }" class="button button-blue">
      <i class="fa fa-arrow-left"></i> Back to Budget Manager
    </router-link>
  </div>
</template>

<script>
import YearlyBudget from "./partials/YearlyBudget";
import Logs from "./partials/Logs";
import FundManager from "./partials/FundManager";
import moment from "moment";

import Loading from "@/components/ui/Loading";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "BudgetShow",
  components: {
    YearlyBudget,
    Logs,
    FundManager,
    Loading
  },
  data() {
    return {
      status: {
        loading: true,
        error: false
      },
      budget: {},
      budgets: []
    };
  },
  created() {
    this.updateData();

    if (this.getUser.role_id > 2 && this.getUser.department_id !== 1) {
      this.$router.go(-1);
    }
  },
  computed: {
    ...mapGetters(["getYear", "getMonth", "getUser"])
  },
  methods: {
    ...mapActions(["setYear"]),
    async updateData() {
      this.status.loading = true;
      let response = await this.$http.get(
        "/paid-media-budgets/" + this.$route.params.clientId,
        { params: { year: this.getYear, month: this.getMonth } }
      );
      if (response.data.budgets.length == 0) {
        this.status.error = true;
        this.status.loading = false;
      } else {
        this.budget = response.data.budget;
        this.budgets = response.data.budgets.sort(function(a, b) {
          return a.date_time.replace(/-/g,'') - b.date_time.replace(/-/g,'');
        });
        this.budgets.forEach(budget => {
          budget['month'] = parseInt(budget.date_time.split("-")[1]);
        });
        for (let i = 0; i < 12; i++) {
          if(!this.budgets[i] || this.budgets[i].month != i + 1) {
            this.budgets.splice(i, 0, {
              client_id: this.$route.params.clientId,
              date_time: this.getYear + "-" + (i + 1).toString().padStart(2, "0") + "-01",
              month: i + 1
            });
          }
        }
        this.status.error = false;
        this.status.loading = false;
      }
    },
    goBack() {
      let year = +moment().format("YYYY");
      if (year < this.getYear) {
        this.setYear({ year: this.getYear - 1 });
        this.updateData();
      } else {
        this.setYear({ year: this.getYear + 1 });
        this.updateData();
      }
    }
  }
};
</script>

<style lang="scss">
#budget-show {
  .error-panel {
    text-align: center;
    .message {
      font-size: 18px;
    }
  }
}
</style>
